import IonAlert from '../../../../../components/Modal/ModalAlert';
import IonToolbar from '../../../../../components/Modal/ModalToolbar';
// import '@capacitor-community/http';
import { IonButton, IonButtons, IonCol, IonContent, IonDatetime, IonFooter, IonGrid, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonList, IonLoading, IonPopover, IonRow, IonSelect, IonSelectOption, IonTitle, IonToggle, useIonViewDidEnter } from '@ionic/react';
import { arrowBack } from 'ionicons/icons';
import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { alteraEquipe, cadastraEquipe, requestService } from '../../../../../Utils/Services';
import './ProspectsCad.css';

type MyModalProps = {
  usuario: any;
  inputRef: any;
  closeAction: Function;
  closeActionSimple: Function;
}

const ProspectsCad: React.FC<MyModalProps> = (props: MyModalProps) => {

  const history = useHistory();

  const [textToast, setTextToast] = useState("");
  const [primeiroFoco, setPrimeiroFoco] = useState(false);
  const [pk, setPk] = useState("");
  const [retornoPk, setRetornoPk] = useState("");
  const [retornoNome, setRetornoNome] = useState("");
  const [cpf, setCPF] = useState("");
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [telefone, setTelefone] = useState("");
  const [endereco, setEndereco] = useState("");
  const [dataAniversario, setDataAniversario] = useState("");
  const [dataAniversarioBr, setDataAniversarioBr] = useState("");
  const campoTelefone = useRef<any>(null);
  const [selected, setSelected] = useState<any>("prospect");
  const [selectedColor, setSelectedColor] = useState<any>();
  const [showIncluirUsuario, setShowIncluirUsuario] = useState(false);
  const [alteracao, setAlteracao] = useState(false);
  const [showSucesso, setShowSucesso] = useState(false);
  const [showErro, setShowErro] = useState(false);
  const [lojas, setLojas] = useState<string>(JSON.parse(window.localStorage.getItem("lojas") || "[]")[0]?.empresaLojaId || "");
  const [botaoAtivo, setBotaoAtivo] = useState(true);
  const [showLoading, setShowLoading] = useState(false);
  const [checkedAtivo, setCheckedAtivo] = useState(true);
  const [selectedCanal, setSelectedCanal] = useState<any>("");
  const [showModalDataCad, setShowModalDataCad] = useState(false);
  const popover1 = useRef<HTMLIonPopoverElement>(null);


  const [chamadaRealizada, setChamadaRealizada] = useState(false);
  if (!chamadaRealizada) {
    if (props.usuario) {

      setChamadaRealizada(true);
      setAlteracao(true);
      setPk(props.usuario.pk);
      setCPF(formatCPF(props.usuario.cpf));
      setNome(props.usuario.nome);
      setSelectedColor(props.usuario.color);
      setEndereco(props.usuario.endereco);
      setCheckedAtivo(props.usuario.statusUsuario == "ativo");
      setEmail(props.usuario.email);
      setTelefone(formataTelefone(props.usuario.telefone));
      if (props.usuario.dataAniversario) {
        setDataAniversario(props.usuario.dataAniversario);
        setDataAniversarioBr(new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(

          Date.parse(props.usuario.dataAniversario)
        ));
      }
      setSelected(props.usuario.perfil);
      setSelectedCanal(props.usuario.canal);
      let arrayLojas: string[] = [];
      props.usuario.lojas.map((valor: any) => (
        arrayLojas.push(valor.empresaLojaId)
      ));
      setLojas(arrayLojas[0]);
    }
  }

  useEffect(() => {
    // Define o foco no input quando o componente é montado
    if (props.inputRef.current) {
      props.inputRef.current.focus();
    }
  }, [props.inputRef]);

  useIonViewDidEnter(() => {
    //console.log("Prospects cad2", props.usuario);

  });

  function onChangeCPF(e: any) {

    setPrimeiroFoco(true);
    e.persist();
    e.preventDefault();


    if (e.target.value.length > 14) {
      e.target.value = e.target.value.substring(0, 14);
      setCPF(e.target.value.substring(0, 14));
      return;
    }

    let val = e.target.value;
    var cpfval = val.replace(/\D/g, "")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})/, "$1-$2")
      .replace(/(-\d{2})\d+?$/, "$1");
    setCPF(cpfval);

  }

  function onKeyUpTelefone(e: any) {

    e.persist();
    e.preventDefault();

    if (e.target.value.length > 15) {
      e.target.value = e.target.value.substring(0, 15);
      setTelefone(e.target.value.substring(0, 15));
      return;
    }

    let val = e.target.value;

    const maskPhone = val
      .replace(/\D/g, "")
      .replace(/(\d{2})(\d)/, "($1) $2")
      .replace(/(\d{5})(\d)/, "$1-$2")
      .replace(/(-\d{4})(\d+?)$/, "$1");
    setTelefone(maskPhone);
  }

  function formatCPF(e: string) {
    let cpfval = e.replace(/\D/g, "")
    cpfval = cpfval.replace(/(\d{3})(\d)/, "$1.$2")
    cpfval = cpfval.replace(/(\d{3})(\d)/, "$1.$2")
    cpfval = cpfval.replace(/(\d{3})(\d{1,2})$/, "$1-$2")
    console.log(cpfval);
    return cpfval;
  }

  const openPopoverCad = (e: any) => {
    popover1.current!.event = e;
    setShowModalDataCad(true);
  };

  function formataTelefone(numero: any) {
    if (numero?.length == 13) {
      let BRNumber = numero.replace("55", "").match(/(\d{2})(\d{5})(\d{4})/);
      BRNumber = "(" + BRNumber[1] + ") " + BRNumber[2] + "-" + BRNumber[3];
      return BRNumber;
    }
    else if (numero?.length == 12) {
      let BRNumber = numero.replace("55", "").match(/(\d{2})(\d{4})(\d{4})/);
      BRNumber = "(" + BRNumber[1] + ") " + BRNumber[2] + "-" + BRNumber[3];
      return BRNumber;
    }
    else { return "" };
  }

  function cadastrar() {

    console.log("aaaa", selected);

    if (cpf.trim().length > 0 && cpf.trim().length < 14) {
      setTextToast("CPF Inválido.");
      setShowErro(true);
    }
    else {

      if (nome.length == 0 || telefone.length != 15 || selected === undefined || selected === "" || selectedCanal === "" ||
        (
          (window.localStorage.getItem("lojas") && JSON.parse(window.localStorage.getItem("lojas") || "").length > 0 && lojas.length < 1)
        )
      ) {

        setTextToast("Todos os campos com * são obrigatórios.");
        setShowErro(true);
      }
      else {
        setShowIncluirUsuario(true);
      }
    }


  }

  return (
    <>
      <IonHeader>
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonIcon slot="icon-only" icon={arrowBack} onClick={() => props.closeActionSimple()} />
          </IonButtons>
          <IonTitle>Cadastro de prospects</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonGrid>
          <IonRow>
            <IonCol>
              <IonList>
                <IonItem lines="none">
                  <IonLabel position="stacked">Nome*</IonLabel>
                  <IonInput disabled={alteracao} placeholder="Nome" value={nome} ref={(ref) => props.inputRef.current = ref} autoCorrect='true' autoCapitalize='true' required onIonInput={(e: any) => setNome(e.target.value)}></IonInput>
                </IonItem>

                <IonItem lines="none">
                  <IonLabel position="stacked">Telefone*</IonLabel>
                  <IonInput disabled={alteracao} ref={(ref) => campoTelefone.current = ref} type="tel" maxlength={15} placeholder="(__) _____-____" required value={telefone} onKeyUp={onKeyUpTelefone} />
                </IonItem>

                <IonItem lines="none" hidden={alteracao} >
                  <IonLabel>Canal*</IonLabel>

                  <IonSelect name='Canal' placeholder='Selecione' title='Canal' value={selectedCanal} cancelText="Cancel" okText="Ok" onIonChange={e => { setSelectedCanal(e.detail.value); }} slot="end">

                    <IonSelectOption value="carteira">carteira</IonSelectOption>
                    <IonSelectOption value="whatsapp">whatsapp</IonSelectOption>
                    <IonSelectOption value="app">app</IonSelectOption>
                    <IonSelectOption value="site">site</IonSelectOption>
                    <IonSelectOption value="insta">insta</IonSelectOption>
                    <IonSelectOption value="face">face</IonSelectOption>
                    <IonSelectOption value="indicação">indicação</IonSelectOption>
                    <IonSelectOption value="outros">outros</IonSelectOption>

                  </IonSelect>
                </IonItem>

                <IonItem lines="none">
                  <IonLabel position="stacked">CPF</IonLabel>
                  <IonInput disabled={alteracao} type="tel" maxlength={14} placeholder="___.___.___-__" required value={cpf} onKeyUp={onChangeCPF} />
                </IonItem>

                <IonItem lines="none">
                  <IonLabel position="stacked">E-mail</IonLabel>
                  <IonInput value={email} type='email' autoCorrect='true' placeholder="Digite o e-mail" onIonInput={(e: any) => setEmail(e.target.value)}></IonInput>
                </IonItem>

                <IonItem lines="none">
                  <IonLabel position="stacked">Aniversário</IonLabel>
                  <IonInput value={dataAniversarioBr} placeholder="Selecione" onClick={e => { openPopoverCad(e); }}></IonInput>
                </IonItem>

                <IonItem lines="none" hidden={!alteracao} >
                  <IonLabel>Ativo</IonLabel>
                  <IonToggle slot='end' checked={checkedAtivo} onIonChange={e => {
                    setCheckedAtivo(e.detail.checked);
                  }} />

                </IonItem>

                <IonItem disabled={alteracao} lines="none" hidden={(window.localStorage.getItem("lojas") && JSON.parse(window.localStorage.getItem("lojas") || "").length > 1) ? false : true}>
                  <IonLabel position='stacked'>Lojas</IonLabel>
                </IonItem>
                <IonItem disabled={alteracao} lines="none" hidden={(window.localStorage.getItem("lojas") && JSON.parse(window.localStorage.getItem("lojas") || "").length > 1) ? false : true}>
                  <IonLabel position='stacked'></IonLabel>
                  <IonSelect name='Lojas' placeholder='Selecione' title='Lojas' value={lojas} cancelText="Cancel" okText="Ok" onIonChange={e => { setLojas(e.detail.value); }} slot="end">
                    {JSON.parse(window.localStorage.getItem("lojas") || "[]").map((valor: any) => (
                      <IonSelectOption value={valor.empresaLojaId}>{valor.empresaLojaNome}</IonSelectOption>
                    ))}
                  </IonSelect>
                </IonItem>
              </IonList>
            </IonCol>
          </IonRow>
        </IonGrid>

        <IonAlert isOpen={showIncluirUsuario}
          onDidDismiss={() => setShowIncluirUsuario(false)}
          header={'Cadastro de usuário'}
          message={'Você <strong>confirma</strong> inclusão?'}
          buttons={[
            {
              text: 'Cancelar',
              role: 'cancel',
            },
            {
              text: 'Confirmar',
              cssClass: 'primary',
              handler: () => {

                let dataNiver = "";

                console.log("dataAniversario", dataAniversario);
                if (dataAniversario) {
                  dataNiver = dataAniversario;
                }
                const objectRequest = {
                  cpf: cpf.replace("-", "").replace(".", "").replace(".", ""),
                  pk: pk,
                  nome: nome,
                  email: email,
                  endereco: endereco,
                  color: selectedColor,
                  telefone: (telefone ? "55" + telefone.replace("(", "").replace(")", "").replace(" ", "").replace("-", "") : ""),
                  perfil: selected,
                  canal: selectedCanal,
                  statusUsuario: checkedAtivo ? "ativo" : "inativo",
                  dataAniversario: dataNiver,
                  empresaMarca: localStorage.getItem("empresaMarca") || "",
                  lojas: JSON.parse(window.localStorage.getItem("lojas") || "[]").filter((value: any) => {
                    return lojas.includes(value.empresaLojaId);
                  })
                }


                if (!alteracao) {

                  requestService(cadastraEquipe.url, {
                    method: cadastraEquipe.method,
                    headers: [["token", localStorage.getItem("token") || ""]],
                    credentials: 'include',
                    body: JSON.stringify(objectRequest)
                  },
                    history,
                    (response: any) => {
                      setRetornoPk(response.usuario.pk);
                      setRetornoNome(response.usuario.nome);
                      setNome("");
                      setCPF("");
                      setSelectedCanal("");
                      setSelectedColor("");
                      setEndereco("");
                      setTelefone("");
                      setCheckedAtivo(true);
                      setEmail("");
                      setDataAniversario("");
                      setSelected("usuario");
                      setTextToast("Cadastro realizado com sucesso.");
                      setShowSucesso(true);
                    },
                    (error: any) => {
                      setTextToast(error.message);
                      setShowErro(true);
                    });
                }
                else {
                  requestService(alteraEquipe.url, {
                    method: alteraEquipe.method,
                    headers: [["token", localStorage.getItem("token") || ""]],
                    credentials: 'include',
                    body: JSON.stringify(objectRequest)
                  },
                    history,
                    (response: any) => {
                      setNome("");
                      setCPF("");
                      setSelectedCanal("");
                      setSelectedColor("");
                      setEndereco("");
                      setTelefone("");
                      setCheckedAtivo(true);
                      setEmail("");
                      setDataAniversario("");
                      setSelected("usuario");
                      setTextToast("Alteração realizada com sucesso.");
                      setShowSucesso(true);
                    },
                    (error: any) => {
                      setTextToast(error.message);
                      setShowErro(true);
                    });
                }
              }
            }
          ]}
        />

        <IonPopover ref={popover1}
          isOpen={showModalDataCad}
          onDidDismiss={() => setShowModalDataCad(false)} >
          <IonContent>
            <IonDatetime

              presentation='date'

              onIonChange={e => {

                if (e.detail.value) {
                  let data = e.detail.value.toString().substring(0, 10);
                  const dataFormatada = new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(
                    Date.parse(data)
                  );
                  setDataAniversarioBr(dataFormatada);
                  setDataAniversario(data);
                }
              }}></IonDatetime>
          </IonContent>
        </IonPopover >

        <IonAlert isOpen={showSucesso}
          onDidDismiss={() => { setShowSucesso(false); }}
          header={'Sucesso'}
          message={textToast}
          backdropDismiss={false}
          buttons={[
            {
              text: 'OK',
              handler: () => { setShowSucesso(false); props.closeAction(retornoPk, retornoNome); }
            }
          ]} />

        <IonAlert isOpen={showErro}
          onDidDismiss={() => setShowErro(false)}
          header={'Erro'}
          message={textToast}
          buttons={['OK']}
        />

        <IonLoading
          cssClass='my-custoDm-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          message={'Incluindo...'}

        />

      </IonContent>
      <IonFooter className="ion-no-border">
        <IonToolbar>
          <IonButton disabled={!botaoAtivo} onClick={() => cadastrar()} expand="block" type="submit">SALVAR</IonButton>
        </IonToolbar>
      </IonFooter>
    </>
  );
};

export default ({ usuario, inputRef, closeAction, closeActionSimple }: { usuario: any, inputRef: any, closeAction: Function, closeActionSimple: Function }) => (
  <ProspectsCad usuario={usuario} inputRef={inputRef} closeAction={closeAction} closeActionSimple={closeActionSimple}>
  </ProspectsCad>
)